// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { CartProvider } from "./Component/CartContext";


// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<CartProvider> <App /> </CartProvider>);


// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
   import secureLocalStorage from "./Component/storage";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CartProvider } from "./Component/CartContext";

// NAYA: har API call ke saath token bhejo
axios.interceptors.request.use((config) => {
  const token = secureLocalStorage.getItem("n_token");
  if (token && config.url?.startsWith(process.env.REACT_APP_API)) {
    config.headers.token = token;
  }
  return config;
});

// 401 aane par logout
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || "";
    const isAuthCall = /\/(login|signup|verify_signup_otp|forget_pin|verify_otp|resend_otp)/.test(url);
    if (error.response?.status === 401 && !isAuthCall) {
      secureLocalStorage.clear();
      localStorage.removeItem("ssstoken");
      localStorage.removeItem("localdata");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<CartProvider> <App /> </CartProvider>);

reportWebVitals();
